if (!customElements.get('gifting-carousel')) {
  customElements.define('gifting-carousel', class GiftingCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.gifting-carousel__slide'));
      this.tabs = Array.from(this.querySelectorAll('[data-slide-to]'));
      this.previousButton = this.querySelector('[data-previous]');
      this.nextButton = this.querySelector('[data-next]');
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.interval = Number(this.dataset.interval) || 5000;

      if (this.slides.length < 2) return;

      this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1, true));
      this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1, true));
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.show(Number(tab.dataset.slideTo), true)));
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
      this.addEventListener('touchstart', (event) => { this.touchStartX = event.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (event) => this.handleSwipe(event), { passive: true });
      document.addEventListener('shopify:block:select', (event) => this.selectEditorBlock(event));
      this.startAutoplay();
    }

    disconnectedCallback() { this.stopAutoplay(); }

    show(index, userInitiated = false) {
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === this.currentIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      if (userInitiated) this.restartAutoplay();
    }

    handleSwipe(event) {
      if (typeof this.touchStartX !== 'number') return;
      const distance = event.changedTouches[0].clientX - this.touchStartX;
      if (Math.abs(distance) > 50) this.show(this.currentIndex + (distance < 0 ? 1 : -1), true);
      this.touchStartX = null;
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stopAutoplay();
      this.autoplayTimer = window.setInterval(() => this.show(this.currentIndex + 1), this.interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    restartAutoplay() { this.stopAutoplay(); this.startAutoplay(); }

    selectEditorBlock(event) {
      const slide = event.target.closest('.gifting-carousel__slide');
      if (!slide || !this.contains(slide)) return;
      this.stopAutoplay();
      this.show(Number(slide.dataset.slideIndex));
    }
  });
}
